const HOUR_MS = 60 * 60 * 1000;

/**
 * The ONE `lookbackMs` this app may ask `getDomainEvents` for.
 *
 * `lookbackMs` is deliberately OUTSIDE the endpoint's cache key — `serializeQueryArgs`
 * keys on `view` alone, so every consumer accumulates into one entry, and `forceRefetch`
 * only refetches for a WIDER window. Two different spans against that single entry
 * therefore misbehave in both directions: the narrower caller silently renders whatever
 * the wider one already fetched (no refetch, since its arg is smaller), and the wider
 * caller's `eventFreshness` seeds from whichever response landed first.
 *
 * It lives HERE, beside the endpoint whose contract it is, rather than in whichever
 * feature happened to need it first. It was in `domains/map/timeline` and the admin
 * events workbench then introduced a second 30-minute span into the same entry — which
 * made `/admin` render the map's full 48 h feed with `isLoading` false and an empty
 * state claiming "the last 30 minutes". A constraint owned by one consumer is not
 * reachable by the next one that needs it; owned by the entity, it is.
 *
 * Every caller of `useGetDomainEventsQuery` passes this. If you need a different span,
 * the endpoint needs `lookbackMs` in its cache key first.
 */
export const DOMAIN_EVENT_FEED_LOOKBACK_MS = 48 * HOUR_MS;

/**
 * Hard ceiling on the rolling log. Time trimming keeps it to the 48 h window,
 * about 36k rows on a busy day; this bounds memory when a burst outruns it.
 */
export const DOMAIN_EVENT_LOG_MAX_ROWS = 60_000;
